import { IPoint } from '@src/slide/infrastructure/module/independent/graphic/point/point.interface';

export function distanceFromPointToSegment(p: IPoint, a: IPoint, b: IPoint): number {
    const l2 = distanceBetweenPoints(a, b) ** 2;
    if (l2 === 0) return distanceBetweenPoints(p, a);

    const t = (((p.x - a.x) * (b.x - a.x)) + ((p.y - a.y) * (b.y - a.y))) / l2;
    if (t < 0) return distanceBetweenPoints(p, a);
    if (t > 1) return distanceBetweenPoints(p, b);

    return distanceBetweenPoints(p, { x: a.x + (t * (b.x - a.x)), y: a.y + (t * (b.y - a.y)) });
}

export function distanceBetweenPoints(a: IPoint, b: IPoint): number {
    return Math.sqrt(((a.x - b.x) ** 2) + ((a.y - b.y) ** 2));
}
